import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoSonos = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 48"
    {...props}
  >
    <g clipPath="url(#Logo_Sonos_svg__a)">
      <path
        fill="#222"
        d="M52.722 21.81v13.285h-3.069V14.308l13.731 13.873V14.825h3.07v20.863zm31.807-7.8c-6.007 0-10.892 4.927-10.892 10.987 0 6.058 4.885 10.984 10.892 10.984 6.005 0 10.893-4.926 10.893-10.984 0-6.06-4.888-10.987-10.893-10.987m0 18.851c-4.258 0-7.724-3.528-7.724-7.864s3.466-7.864 7.724-7.864c4.26 0 7.722 3.528 7.722 7.864s-3.463 7.864-7.722 7.864M31.569 14.01c-6.008 0-10.893 4.927-10.893 10.987 0 6.058 4.885 10.984 10.892 10.984 6.009 0 10.893-4.926 10.893-10.984 0-6.06-4.884-10.987-10.893-10.987m0 18.851c-4.26 0-7.723-3.528-7.723-7.864s3.463-7.864 7.722-7.864c4.258 0 7.724 3.528 7.724 7.864s-3.466 7.864-7.724 7.864m-24.254-6.32-.013-.006c-2.05-.657-3.423-1.304-4.457-2.101-1.479-1.136-2.23-2.586-2.23-4.308 0-1.612.743-3.184 2.04-4.32 1.323-1.16 3.147-1.796 5.133-1.796 4.159 0 6.535 2.794 6.635 2.914l-2.524 1.72c-.584-.44-2.12-1.43-4.11-1.43-2.502 0-3.997 1.48-3.997 2.912 0 .999.543 2.097 4.471 3.358l.015.002c2.046.655 3.423 1.305 4.457 2.1 1.48 1.138 2.23 2.588 2.23 4.31 0 1.612-.744 3.186-2.043 4.32-1.32 1.157-3.144 1.794-5.132 1.794-4.158 0-6.534-2.792-6.634-2.913l2.526-1.719c.583.441 2.119 1.43 4.107 1.43 2.503 0 4-1.478 4-2.912 0-.999-.542-2.097-4.474-3.355m100.52 0-.014-.006c-2.049-.657-3.423-1.304-4.456-2.102-1.477-1.136-2.232-2.585-2.232-4.307 0-1.613.746-3.184 2.043-4.32 1.319-1.16 3.141-1.796 5.133-1.796 4.158 0 6.536 2.794 6.637 2.914l-2.527 1.72c-.583-.44-2.118-1.43-4.11-1.43-2.504 0-3.999 1.48-3.999 2.912 0 .999.543 2.097 4.475 3.358l.015.002c2.048.655 3.421 1.305 4.456 2.1 1.476 1.138 2.228 2.588 2.228 4.31 0 1.612-.743 3.186-2.038 4.32-1.323 1.157-3.147 1.794-5.137 1.794-4.157 0-6.532-2.792-6.632-2.913l2.524-1.719c.585.441 2.116 1.43 4.108 1.43 2.505 0 3.997-1.478 3.997-2.912 0-.999-.541-2.097-4.471-3.355"
      />
    </g>
    <defs>
      <clipPath id="Logo_Sonos_svg__a">
        <path
          fill="#fff"
          d="M.615 0h115v48h-115z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoSonos;
